module.exports = __webpack_public_path__ + "media/flags/bg-e54d872c.svg";